/** @prettier */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import ChildrenPropsContext from '@xanadu/ui-shared/contexts/ChildrenPropsContext';
import { useReduxBridge } from '@xanadu/ui-shared/contexts/ReduxBridgeContext';

import { getClientString } from '../../../utils';

import styles from './SubHeader.module.scss';

const SubHeader = ({ cashierEnabled, isLoggedIn, promotionsEnabled, product, t = (v) => v }) => {
  const { clientName, clientSite } = useReduxBridge() || {};

  const upperContext = React.useContext(ChildrenPropsContext) || {};

  const {
    featuresFlags: { displayNativeApps = true } = {},
    childrenProps: {
      SubHeader: { b2bLink = '', brokerageLinkEnabled = false, insightLinkEnabled = false } = {},
    } = {},
    customization: { SubHeader: { internationalPartnersLogo = [] } = {} } = {},
  } = upperContext;

  const clientString = getClientString(clientName, clientSite);

  const { url: partnerImageUrl } = internationalPartnersLogo[0] || {};

  const subHeaderClass = classNames({
    [styles.subHeader]: true,
    [styles[`subHeader--${product}`]]: true,
  });

  return (
    <div className={subHeaderClass}>
      {cashierEnabled && (
        <Link
          to={
            isLoggedIn
              ? '/account/safer-gambling'
              : '/page/rules_and_regulations/responsible-gambling'
          }
          data-hook="rg-page"
          className=".gtm_cta"
        >
          {t('Safer Gambling')}
        </Link>
      )}
      {displayNativeApps && (
        <Link
          to="/page/about/mobile-applications/"
          data-hook="download-apps-top"
          className=".gtm_cta"
        >
          {t('Download Apps')}
        </Link>
      )}
      {promotionsEnabled && (
        <Link to={'/promotions'} data-hook="promotions-top" className=".gtm_cta">
          {t('Promotions')}
        </Link>
      )}
      {b2bLink ? (
        <Link to={b2bLink} target="_blank" data-hook="matchbook-b2b" className=".gtm_cta">
          {`${clientString} B2B`}
        </Link>
      ) : null}
      {brokerageLinkEnabled ? (
        <Link
          to="/promo/brokerage"
          data-hook="brokerage-top"
          target="_blank"
          rel="noopener noreferrer"
          className=".gtm_cta"
        >
          Brokerage
        </Link>
      ) : null}
      {insightLinkEnabled ? (
        <Link
          to="https://insights.matchbook.com"
          target="_blank"
          data-hook="insights-top"
          className=".gtm_cta"
        >
          Insights
        </Link>
      ) : null}
      {Boolean(partnerImageUrl) && (
        <div
          className={styles.advertisement}
          style={{
            backgroundImage: `url(${partnerImageUrl})`,
          }}
        />
      )}
    </div>
  );
};

SubHeader.propTypes = {
  promotionsEnabled: PropTypes.bool.isRequired,
  cashierEnabled: PropTypes.bool.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  product: PropTypes.string.isRequired,
};

export default withTranslation()(SubHeader);
